<template>
    <ModalBox class="ChangePasswordBox" v-model="show">
        <div class="pass-top-text">修改密码</div>
        <div class="input-note">原密码</div>
        <input
            class="pass-input"
            type="password"
            v-model="originalPass"
            placeholder="请输入原先的密码"
        >
        <div class="input-note">新密码</div>
        <input
            class="pass-input"
            type="password"
            v-model="newPass"
            placeholder="请输入新的密码"
        >
        <div class="input-note">确认新密码</div>
        <input
            class="pass-input"
            type="password"
            v-model="newPassVerify"
            placeholder="请再次输入新的密码"
        >
        <div
            class="pass-button flex-center-hori"
            @click="changePass"
        >
            <div>保存</div>
        </div>
    </ModalBox>
</template>
<script>
import accountAPI from '@/api/account.api.js';
import ModalBox from './ModalBox.vue';
export default {
    name: 'ChangePasswordBox',
    components: { ModalBox },
    data () {
        return {
            show: false,
            originalPass: '',
            newPass: '',
            newPassVerify: ''
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        this.show = this.visible;
    },
    watch: {
        visible (val) {
            this.show = val;
        },
        show (val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        async changePass () {
            if (this.newPass !== this.newPassVerify) return;
            await accountAPI.changePass({
                'oldPassword': this.originalPass.toString(),
                'newPassword': this.newPass.toString()
            });
            this.$message.success('密码修改成功');
            this.show = false;
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.ChangePasswordBox {
    .pass-top-text {
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        font-weight: 500;
        line-height: 30px;
        margin: 32px 0 12px;
    }

    .input-note {
        width: 400px;
        height: 27px;
        margin: 24px 0 8px;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
    }

    .input-note.warn {
        margin: 12px 0 8px;
        font-size: 14px;
        color: red;
    }

    .pass-input {
        width: 400px;
        height: 48px;
        box-sizing: border-box;
        background: #FFFFFF;
        font-size: 16px;
        border-radius: 4px;
        border: 1px solid rgba(7, 22, 51, 0.1);
        padding: 0px 12px;
    }

    .pass-button {
        width: 400px;
        height: 48px;
        background: #126CFF;
        border-radius: 4px;
        user-select: none;
        cursor: pointer;
        margin: 32px 0 36px;

        >div {
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 30px;
        }
    }
}
</style>
